{
  "line.carriage.name": "Vrachtkosten",
  "line.carriage.description": "Vervoer van {origin} naar {destination}, afgeleverd op {delivered_on}.",
  "note.cash_on_delivery": "Rembours bij aflevering geïnd: {amount} {currency} (CMR-vak 15). Dit bedrag staat niet op deze factuur.",
  "document.proof_of_delivery": "Elektronisch afleverbewijs (ePOD)"
}
